import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { OrderDto, OrderResultDto, TeamWorkDto } from "../models/dtos";
import { BaseService } from "./base.service";

@Injectable()
export class OrderService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getOrder(): Observable<OrderDto> {
        return this.httpService.get<OrderDto>(this.apiUrl + 'order', null);
    }

    getNationalOrder(): Observable<OrderDto> {
        return this.httpService.get<OrderDto>(this.apiUrl + 'order/national', null);
    }


    save(order: OrderDto, isNational: boolean): Observable<OrderResultDto> {
        const url = isNational ? this.apiUrl + 'order/national' : this.apiUrl + 'order';
        return this.httpService.put<OrderResultDto>(url, null, order);
    }

    getTeamWork(playerIds: number[]): Observable<TeamWorkDto> {
        var request = new TeamWorkDto();
        request.playerIds = playerIds;

        return this.httpService.post<TeamWorkDto>(this.apiUrl + 'order/teamwork', null, request);
    }
}